// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3RkXQ","notes":"Notes_notes__1Ilpp"};